import "./KaboodleModal.scss";

import type { ReactNode } from "react";
import React from "react";
import ReactModal from "react-modal";

type ModalSize = "default" | "large" | "extra-large";

interface KaboodleModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  title?: string;
  className?: string;
  footer?: ReactNode;
  size?: ModalSize;
}

const KaboodleModal: React.FC<KaboodleModalProps> = ({
  isOpen,
  onClose,
  children,
  title,
  className = "",
  footer,
  size = "default",
}) => {
  ReactModal.setAppElement("#kaboodle-react-app");

  return (
    // @ts-expect-error - ReactModal type incompatibility with React 18 types
    <ReactModal
      isOpen={isOpen}
      closeTimeoutMS={250}
      onRequestClose={onClose}
      contentLabel={title}
      shouldCloseOnOverlayClick={true}
      className={`KaboodleModal KaboodleModal--${size} ${className}`}
      overlayClassName="KaboodleModal__Overlay"
    >
      <button className="KaboodleModal__Close" onClick={onClose}>
        &times;
      </button>
      <div className="KaboodleModal__Content">
        {title && <h2 className="KaboodleModal__Title">{title}</h2>}

        <div className="KaboodleModal__Body">{children}</div>
      </div>
      {footer && <div className="KaboodleModal__Footer">{footer}</div>}
    </ReactModal>
  );
};

export default KaboodleModal;
